import React, { useEffect, useState } from "react";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { getStripePublicKey } from "../apis/keys.api";

const StripeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [stripePromise, setStripePromise] =
    useState<Promise<Stripe | null> | null>(null);

  useEffect(() => {
    // fetch("/config")
    //   .then((res) => res.json())
    //   .then((data) => {
    //     setStripePromise(loadStripe(data.stripePublicKey));
    //   });
    getStripePublicKey().then((data) => {
      setStripePromise(loadStripe(data.stripePublicKey));
    });
  }, []);

  if (!stripePromise) return <p>Loading Stripe...</p>;

  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeProvider;
